import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

class DidYouMeanComboComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldValue: props.fieldValue
    };
  }

  componentDidUpdate(prevProps) {
    const { fieldValue } = this.props;
    if (prevProps.fieldValue !== fieldValue) {
      this.setState({ fieldValue });
    }
  }

  onDidYouMeanChange(event) {
    const { input } = this.props;
    this.setState({ fieldValue: event.target.value });
    if (input.onChange) {
      input.onChange(event);
    }
  }

  getCleanedItemList() {
    const { items } = this.props;
    return items.map(item => item.trim().toLowerCase());
  }

  render() {
    const { fieldValue } = this.state;
    const { name, className, items, input, disabled } = this.props;
    return (<div className="didyoumeancombo">
      <select
        name={ name }
        className={ className }
        { ...input }
        value={ fieldValue }
        disabled={ disabled }
        onChange={ event => this.onDidYouMeanChange(event) }
      >
        { !this.getCleanedItemList().includes(fieldValue.toLowerCase()) && <option disabled value={ fieldValue }>{ fieldValue }</option> }
        <option value="">Select to clear the field...</option>
        { items && items.length > 0 && items.map(item => <option key={ item.replace(' ', '_') } value={ item }>{ item }</option>) }
      </select>
    </div>);
  }
}

DidYouMeanComboComponent.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  fieldValue: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func
  }).isRequired,
  disabled: PropTypes.bool
};

DidYouMeanComboComponent.defaultProps = {
  name: '',
  className: null,
  fieldValue: null,
  disabled: false
};

function mapStateToProps(state, ownProps) {
  const fieldValue = ownProps.input && ownProps.input.value;
  return {
    fieldValue
  };
}

// eslint-disable-next-line import/prefer-default-export
export const DidYouMeanCombo = connect(
  mapStateToProps
)(DidYouMeanComboComponent);
